// Décision de traitement d'un événement `onProjectChange` côté cache Apollo.
//
// - `insertIntoProjectField:<champ>` : INSERT d'un objet porté directement par
//   Project (champ `<type en minuscules>s`, ex. Stakeholder -> stakeholders).
// - `modifyScalars` : merge des champs scalaires dans l'objet normalisé.
// - `reconcile` : refetch ciblé de la section (getProject + flags include*).
//
// Les objets Fishbone ne rentrent pas dans le chemin générique : le champ
// Project est `fishboneBranchs` (pas `fishbonebranchs`) et les FishboneItem
// vivent sous `FishboneBranch.items`, pas sur Project. Toute opération
// (INSERT/MODIFY/REMOVE) passe donc par la réconciliation ciblée.
export type RealtimeStrategy = `insertIntoProjectField:${string}` | 'modifyScalars' | 'reconcile';

const RECONCILE_ONLY_TYPES = new Set(['FishboneBranch', 'FishboneItem']);

export const realtimeStrategyFor = (type: string, operation: string): RealtimeStrategy => {
	if (RECONCILE_ONLY_TYPES.has(type)) return 'reconcile';
	if (operation === 'INSERT') return `insertIntoProjectField:${type.toLowerCase()}s`;
	return 'modifyScalars';
};
